import { VideoGrid } from '../components/VideoGrid';

export default function Index() {
  return (
    <div className="min-h-screen bg-background px-4 py-8 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-[2000px]">
        <VideoGrid />
      </div>
    </div>
  );
}